import * as React from "react";

function SvgAirtable(props, ref) {
  return (
    <svg
      shapeRendering="geometricPrecision"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640.4 544"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M286 6L47.2 104.8c-13.3 5.5-13.1 24.4.2 29.7l239.8 95.1c21.1 8.4 44.5 8.4 65.6 0l239.8-95.1c13.4-5.3 13.5-24.2.2-29.6L354 6c-21.8-9-46.3-9-68 0"
        fill="#fcb400"
      />
      <path
        d="M341.2 281.4V519c0 11.3 11.4 19 21.9 14.9l267.2-103.7c6.1-2.4 10.1-8.3 10.1-14.9V177.7c0-11.3-11.4-19-21.9-14.9L351.3 266.6c-6 2.4-10.1 8.3-10.1 14.8"
        fill="#18bfff"
      />
      <path
        d="M278.9 293.7L199.6 332l-8.1 3.9-167.3 80.2C13.5 421.2 0 413.5 0 401.7v-223c0-4.3 2.2-7.9 5.1-10.7 1.2-1.2 2.6-2.2 4.1-3 4-2.4 9.7-3 14.6-1.1l253.8 100.6c12.8 5.1 13.8 23.1 1.3 29.2"
        fill="#f82b60"
      />
      <path d="M278.9 293.7L199.6 332 5.1 168c1.2-1.2 2.6-2.2 4.1-3 4-2.4 9.7-3 14.6-1.1l253.8 100.6c12.8 5.1 13.8 23.1 1.3 29.2" />
    </svg>
  );
}

export default React.forwardRef(SvgAirtable);
